import cn from 'classnames';
import styles from './KitItem.module.scss';
import { useRouter } from 'next/navigation';

type KitItemProps = {
  className?: string;
  kit: {
    id: number;
    name: string;
    url: string;
  };
  isUnavailable?: boolean;
  isActive?: boolean;
};

export function KitItem({
  className,
  kit,
  isUnavailable,
  isActive,
}: KitItemProps) {
  const wrapperClassName = cn(
    styles.wrapper,
    {
      [styles.unavailable]: isUnavailable,
      [styles.active]: isActive,
    },
    className,
  );
  const { push } = useRouter();

  const handleClick = () => {
    push(kit.url);
  };

  return (
    <div className={wrapperClassName} onClick={handleClick}>
      <span
        className={cn(styles.text, { [styles.unavailableText]: isUnavailable })}
      >
        {kit.name}
      </span>
      {isUnavailable && (
        <img
          src="/svg/cross-line.svg"
          alt="cross-line"
          className={styles.crossLine}
        />
      )}
    </div>
  );
}
